import React, { useState } from "react";
import AbstractButton from "../../components/AbstractButton";
import { ReactComponent as CancelIcon } from "../../../assets/icons/backspace-20-regular.svg?react";
import ForegroundColorSet from "../../../utilities/enums/ForegroundColorSet";
import BackgroundColorSet from "../../../utilities/enums/BackgroundColorSet";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import PartsAppPurchaseOrderLock from "interfaces/PoLock";
import Depot from "interfaces/Depot";

const MultiLockBox = (props: {
  showMultiLockBox: boolean;
  locks: PartsAppPurchaseOrderLock[];
  onProceed(chosenOrder: PartsAppPurchaseOrderLock): void;
  onCancel(): void;
}) => {
  const allDepots = useSelector((state: RootState) => state.root.system.depots);
  const [selectionMade, setSelectioNMade] = useState(false);

  const handleCancel = () => {
    props.onCancel();
  };

  const handleProceed = (e: PartsAppPurchaseOrderLock) => {
    if (!selectionMade) {
      setSelectioNMade(true);
      props.onProceed(e);
    }
  };

  return (
    <>
      <div
        id="multi-lock-modal-parent"
        className={
          "finish-page " +
          (props.showMultiLockBox ? "modal-open" : "modal-closed")
        }
      >
        <div
          id="main-menu-modal-mask"
          onClick={props.onCancel}
          className="modal-mask"
        ></div>
        <div
          id="foreign-depot-modal"
          className="modal-page modal-page-scrollable multi-lock-page"
        >
          <p id="finish-page-title" className="foreign-depot-box">
            Multiple Locked Records Detected
          </p>
          <div className="info-page-section foreign-depot-box">
            You have multiple Purchase Orders locked in your name, please choose
            which to open.
          </div>
          <div className="dialog-card-list">
            {props.locks.map((l: PartsAppPurchaseOrderLock) => (
              <div
                key={l.orderNumber}
                id={"multi-lock-card-" + l.orderNumber}
                className={
                  "dialog-card" + (selectionMade ? ` dialog-disabled` : "")
                }
                onClick={() => handleProceed(l)}
              >
                <div className="dialog-card-title">
                  <b>Order: </b>
                  {l.orderNumber}
                </div>
                <div className="dialog-card-detail">
                  <b>Depot: </b>
                  {allDepots.filter((e: Depot) => e.id == l.depot)[0].shortName}
                </div>
                <div className="dialog-card-detail">
                  <b>Ref: </b>
                  {/*l.reference*/}
                </div>
              </div>
            ))}
          </div>
          <div className="modal-button-span">
            <AbstractButton
              id="stock-unsaved-stay-button"
              text="Back"
              icon={<CancelIcon width="100%" height="100%" />}
              disabled={false}
              activeColor={ForegroundColorSet.Red}
              background={BackgroundColorSet.Black1}
              specialClass={null}
              actionCallback={handleCancel}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MultiLockBox;
